import { render, staticRenderFns } from "./IncidentsTable.vue?vue&type=template&id=69a4bc22&scoped=true"
import script from "./IncidentsTable.vue?vue&type=script&lang=js"
export * from "./IncidentsTable.vue?vue&type=script&lang=js"
import style0 from "./IncidentsTable.vue?vue&type=style&index=0&id=69a4bc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a4bc22",
  null
  
)

export default component.exports